// function sliceSize(dataNum, dataTotal) {
//   return (dataNum / dataTotal) * 360;
// }
// function addSlice(sliceSize, pieElement, offset, sliceID, color) {
//   $(pieElement).append(
//     "<div class='slice " + sliceID + "'><span></span></div>"
//   );
//   var offset = offset - 1;
//   var sizeRotation = -179 + sliceSize;
//   $("." + sliceID).css({
//     transform: "rotate(" + offset + "deg) translate3d(0,0,0)",
//   });
//   $("." + sliceID + " span").css({
//     transform: "rotate(" + sizeRotation + "deg) translate3d(0,0,0)",
//     "background-color": color,
//   });
// }
// function iterateSlices(
//   sliceSize,
//   pieElement,
//   offset,
//   dataCount,
//   sliceCount,
//   color
// ) {
//   var sliceID = "s" + dataCount + "-" + sliceCount;
//   var maxSize = 179;
//   if (sliceSize <= maxSize) {
//     addSlice(sliceSize, pieElement, offset, sliceID, color);
//   } else {
//     addSlice(maxSize, pieElement, offset, sliceID, color);
//     iterateSlices(
//       sliceSize - maxSize,
//       pieElement,
//       offset + maxSize,
//       dataCount,
//       sliceCount + 1,
//       color
//     );
//   }
// }
// function createPie(dataElement, pieElement) {
//   var listData = [];
//   $(dataElement + " span").each(function () {
//     listData.push(Number($(this).html()));
//   });
//   var listTotal = 0;
//   for (var i = 0; i < listData.length; i++) {
//     listTotal += listData[i];
//   }
//   var offset = 0;
//   var color = [
//     "#002253",
//     "#0B3E8A",
//     "#1D59B1",
//     "#4F83CE",
//     "#809DC7",
//     "#D6D6D6",
//   ];
//   for (var i = 0; i < listData.length; i++) {
//     var size = sliceSize(listData[i], listTotal);

//     iterateSlices(size, pieElement, offset, i, 0, color[i]);
//     $(dataElement + " li:nth-child(" + (i + 1) + ")").css(
//       "border-color",
//       color[i]
//     );
//     offset += size;
//   }
// }

// // アニメーションを開始する関数
// function startAnimation() {
//   createPie(".pieID.legend", ".pieID.pie");
// }


// // Intersection Observer を使って要素のビューポートへの入出を監視し、
// // 特定の処理（Processing）関数を実行する関数
// const animationObserver = (elements, timing, processing) => {
//   // Intersection Observerのオプション設定
//   const options = {
//     root: null, // ビューポートを基準とする
//     rootMargin: timing, // ルートのマージンを設定（ビューポートの外側からの監視を可能にする）
//     threshold: 0, // どのくらい交差したら関数（callback）を呼び出すか
//   };

//   // Intersection Observerのコールバック関数
//   const callback = (entries) => {
//     entries.forEach((entry) => {
//       processing(entry, observer);
//     });
//   };

//   // Intersection Observerのインスタンス作成
//   const observer = new IntersectionObserver(callback, options);

//   // NodeListを配列に変換
//   const targetArray = Array.from(elements);

//   // 各要素を監視対象に追加
//   targetArray.forEach((target) => {
//     observer.observe(target);
//   });
// };

// // 要素がビューポートに入った時に「visible」クラスを追加し、監視を停止する処理
// const handleScrollVisible = (entry, observer) => {
//   if (entry.isIntersecting) {
//     // ビューポートに入った時の処理
//     entry.target.classList.add('visible');

//     if (entry.target.classList.contains('dondon')) {
//       startAnimation();
//     }

//     observer.unobserve(entry.target); // 監視を解除
//   }
// };

// // 動画要素がビューポートに入っていたら再生、出ていたら停止する処理
// const handleScrollPlayMovie = (entry, observer) => {
//   if (entry.isIntersecting) {
//     // ビューポートに入っている時の処理
//     entry.target.play();
//   } else {
//     // ビューポートから出ている時の処理
//     entry.target.pause();
//   }
// };

// // 対象要素を全て取得
// const targets = document.querySelectorAll('[data-trigger]');
// if (targets.length) {
//   // 対象要素がある時、スクロールに応じて表示するアニメーションを設定
//   animationObserver(targets, '0px 0px -32px 0px', handleScrollVisible);
// }

// // 動画要素を全て取得
// const targets2 = document.querySelectorAll('[data-trigger-video]');
// if (targets2.length) {
//   // 対象要素がある時、ビューポート内に入ると再生、出ると停止するよう設定
//   animationObserver(targets2, '0px', handleScrollPlayMovie);
// }

function sliceSize(dataNum, dataTotal) {
  return (dataNum / dataTotal) * 360;
}
function addSlice(sliceSize, pieElement, offset, sliceID, color) {
  $(pieElement).append(
    "<div class='slice " + sliceID + "'><span></span></div>"
  );
  var offset = offset - 1;
  var sizeRotation = -179 + sliceSize;
  $("." + sliceID).css({
    transform: "rotate(" + offset + "deg) translate3d(0,0,0)",
  });
  $("." + sliceID + " span").css({
    transform: "rotate(" + sizeRotation + "deg) translate3d(0,0,0)",
    "background-color": color,
  });
}
function iterateSlices(
  sliceSize,
  pieElement,
  offset,
  dataCount,
  sliceCount,
  color
) {
  var sliceID = "s" + dataCount + "-" + sliceCount;
  var maxSize = 179;
  if (sliceSize <= maxSize) {
    addSlice(sliceSize, pieElement, offset, sliceID, color);
  } else {
    addSlice(maxSize, pieElement, offset, sliceID, color);
    iterateSlices(
      sliceSize - maxSize,
      pieElement,
      offset + maxSize,
      dataCount,
      sliceCount + 1,
      color
    );
  }
}
function createPie(dataElement, pieElement) {
  var listData = [];
  $(dataElement + " span").each(function () {
    listData.push(Number($(this).html()));
  });
  var listTotal = 0;
  for (var i = 0; i < listData.length; i++) {
    listTotal += listData[i];
  }
  var offset = 0;
  var color = [
    "#002253",
    "#0B3E8A",
    "#1D59B1",
    "#4F83CE",
    "#809DC7",
    "#D6D6D6",
  ];
  for (var i = 0; i < listData.length; i++) {
    var size = sliceSize(listData[i], listTotal);
    iterateSlices(size, pieElement, offset, i, 0, color[i]);
    $(dataElement + " li:nth-child(" + (i + 1) + ")").css(
      "border-color",
      color[i]
    );
    offset += size;
  }
}

// アニメーションを開始する関数
function startAnimation() {
  createPie(".pieID.legend", ".pieID.pie");
}


// Intersection Observer を使って要素のビューポートへの入出を監視し、
// 特定の処理（Processing）関数を実行する関数
const animationObserver = (elements, timing, processing) => {
  // Intersection Observerのオプション設定
  const options = {
    root: null, // ビューポートを基準とする
    rootMargin: timing, // ルートのマージンを設定（ビューポートの外側からの監視を可能にする）
    threshold: 0, // どのくらい交差したら関数（callback）を呼び出すか
  };

  // Intersection Observerのコールバック関数
  const callback = (entries) => {
    entries.forEach((entry) => {
      processing(entry, observer);
    });
  };

  // Intersection Observerのインスタンス作成
  const observer = new IntersectionObserver(callback, options);

  // NodeListを配列に変換
  const targetArray = Array.from(elements);

  // 各要素を監視対象に追加
  targetArray.forEach((target) => {
    observer.observe(target);
  });
};

// 要素がビューポートに入った時に「visible」クラスを追加し、監視を停止する処理
const handleScrollVisible = (entry, observer) => {
  if (entry.isIntersecting) {
    // ビューポートに入った時の処理
    entry.target.classList.add('visible');

    if (entry.target.classList.contains('dondon')) {
      startAnimation();
    }

    observer.unobserve(entry.target); // 監視を解除
  }
};

// 動画要素がビューポートに入っていたら再生、出ていたら停止する処理
const handleScrollPlayMovie = (entry, observer) => {
  if (entry.isIntersecting) {
    // ビューポートに入っている時の処理
    entry.target.play();
  } else {
    // ビューポートから出ている時の処理
    entry.target.pause();
  }
};

// 対象要素を全て取得
const targets = document.querySelectorAll('[data-trigger]');
if (targets.length) {
  // 対象要素がある時、スクロールに応じて表示するアニメーションを設定
  animationObserver(targets, '0px 0px -32px 0px', handleScrollVisible);
}

// 動画要素を全て取得
const targets2 = document.querySelectorAll('[data-trigger-video]');
if (targets2.length) {
  // 対象要素がある時、ビューポート内に入ると再生、出ると停止するよう設定
  animationObserver(targets2, '0px', handleScrollPlayMovie);
}
